<ryui-modal
  [headerTitle]="title"
  (closeModal)="modalAction(false)"
>
  <div class="body-content">
    {{ bodyText }}
  </div>
  <div class="footer-content">
    <ryui-button
      [size]="'medium'"
      [themes]="'primary'"
      [text]="'Yes'"
      (Event)="modalAction(true)"
    ></ryui-button>
    <ryui-button
      [size]="'medium'"
      [themes]="'inverted'"
      [text]="'No'"
      (Event)="modalAction(false)"
    ></ryui-button>
  </div>
</ryui-modal>
